import type React from 'react';
import SettingStyles from '../../SettingStyle.module.scss';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import { CompanySettingForm } from '~/components/specifics/settings/admin/company_settings/CompanySettingForm';
import type { ItandiAccount } from '~/models/ItandiAccount';

type Props = {
  currentCompany: Exclude<ItandiAccount['company'], null>;
};

export const Page: React.FC<Props> = ({ currentCompany }) => (
  <DefaultV2>
    <ClientSettingLayout>
      <h2 className={SettingStyles.SettingTitle}>会社設定</h2>
      <CompanySettingForm companySetting={currentCompany} />
    </ClientSettingLayout>
  </DefaultV2>
);
